import React from 'react'

type Props = React.ImgHTMLAttributes<HTMLImageElement>
const Img = ({ src, alt, ...props }: Props) => (
  <img src={src} alt={alt || ''} className="w-full h-auto" {...props} />
)

export default Img
